import React, { useState, useEffect } from 'react';
import './SecondHand.css';
import { useNavigate } from 'react-router-dom';

const apiURL = process.env.REACT_APP_API_URL;
const MAX_VISIBLE_IMAGES = 5;

const formatPriceForDisplay = (value) => {
    const numericPrice = Number(value);

    if (!Number.isFinite(numericPrice)) {
        return '0';
    }

    return numericPrice.toString().replace('.', ',');
};

const SecondHand = () => {
    const navigate = useNavigate();
    const [secondHandProducts, setSecondHandProducts] = useState([]);
    const [leftIndex, updateLeftIndex] = useState(0);
    const [rightIndex, updateRightIndex] = useState(MAX_VISIBLE_IMAGES);
    const [productsLength, setProductsLength] = useState(0);

    const leftSlider = () => {
        const newLeftIndex = leftIndex - 1;
        const newRightIndex = rightIndex - 1;

        if (newLeftIndex < 0 && newRightIndex < MAX_VISIBLE_IMAGES) {
            return;
        }

        updateLeftIndex(newLeftIndex);
        updateRightIndex(newRightIndex);
    };

    const rightSlider = () => {
        const newLeftIndex = leftIndex + 1;
        const newRightIndex = rightIndex + 1;

        if (newLeftIndex > (productsLength - MAX_VISIBLE_IMAGES) && newRightIndex > productsLength) {
            return;
        }

        updateRightIndex(newRightIndex);
        updateLeftIndex(newLeftIndex);
    };

    const getSecondHandProducts = async () => {
        try {
            const response = await fetch(`${apiURL}/category-products/reacondicionats`);
            if (response && response.ok) {
                const products = await response.json();
                if (products) {
                    setSecondHandProducts(products);
                    setProductsLength(products.length);
                    return;
                }
            }
        } catch (error) {
            console.error('Error carregant productes reacondicionats');
        }
    };

    useEffect(() => {
        getSecondHandProducts();
    }, []);

    if (secondHandProducts.length === 0) {
        return null;
    }

    return (
        <div className='container'>
            <h1>Reacondicionats</h1>
            <div className='wrapper'>
                <button onClick={leftSlider} disabled={leftIndex === 0} className='nav-button left'>◀</button>

                <div className='products-viewport'>
                    <div className='products-carrousel'
                        style={{ 
                            transform: `translateX(-${leftIndex * (100 / MAX_VISIBLE_IMAGES)}%)`,
                            transition: 'transform 0.5s ease'
                        }}
                    >
                        {secondHandProducts.map((product, index) => (
                            <div key={index} className='individual-product' onClick={() => navigate(`/product/${encodeURIComponent(product.name)}`)}>
                                <div className="secondhand-badge">Reacondicionat</div>
                                <img src={`${product.image}`} className='product-images' alt={product.name} />
                                <span className='product-name'>{product.name}</span>
                                <span className='product-price'>{formatPriceForDisplay(product.price)}€</span>
                            </div>
                        ))}
                    </div>
                </div>

                <button onClick={rightSlider} disabled={rightIndex >= secondHandProducts.length} className='nav-button right'>▶</button>
            </div>
        </div>
    );
};

export default SecondHand;
